import React from "react";
import styled from "styled-components";
import Text from "../utils/Text";
import {CFlex, CMargin, DText, Flex} from "../styles/MarketStyles";
import { FiAlertTriangle } from 'react-icons/fi'
import {LineBreak} from "../styles/InvoiceStyles";
import {ToolboxBtn} from "../styles/dashboard";

const OrdersDeleteModal = ({ onModalBtnClicked }) => {
    return (
        <CFlex fw align={'flex-start'}>
            <Flex fw justify={'space-between'}>
                <DText main fontSize={'m'}>
                    <Text tid={'delete-orders'} />
                </DText>
                <FiAlertTriangle color='#599eff' size={24} />
            </Flex>
            <CMargin margin={'4px'} />
            <LineBreak />
            <CMargin margin={'8px'} />
            <DText main fontSize={'s'}>
                <Text tid={'delete-orders-question'} />
            </DText>
            <CMargin margin={'8px'} />
            <Flex fw>
                <Flex width={'80%'} justify={'space-around'}>
                    <ToolboxBtn submit onClick={() => onModalBtnClicked(true)}>
                        <Text tid="submit" />
                    </ToolboxBtn>
                    <ToolboxBtn cancel onClick={() => onModalBtnClicked(false)}>
                        <Text tid="cancel" />
                    </ToolboxBtn>
                </Flex>
            </Flex>
        </CFlex>
    )
}

const MText = styled.div`
    width: 100%;
    text-align: start;
    color: ${props => props.theme.color || "#ffffff95"};
    font-size: 1.1rem;

    @media screen and (max-width: 480px){
        font-size: 0.75rem;
    }
`

const BtnContainer = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
`

const Btn = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    width: 100px;
    cursor: pointer;
    height: 40px;
    margin-top: 30px;
    background-color: ${props => props.bgColor || "#0f1c2e"};
    color: ${props => props.theme.secondaryBg || "black"};

    @media screen and (max-width: 480px){
        font-size: 0.75rem;
        width: 80px;
        height: 32px;
    }
`


export default OrdersDeleteModal;
